import React, { createContext, useCallback, useMemo, useState } from 'react';

const UserContext = createContext();
const UserManagerContext = createContext();

export const UserContextProvider = ({ children }) => {

    const [user, setUser] = useState({});

    const updateUser = useCallback((updates) => {
        setUser(prevUser => {
            const newUser = { ...prevUser, ...updates };
            return newUser;
        });
    }, []);

    const value = useMemo(
        () => ({ user }),
        [user]
    );

    const managerValue = useMemo(
        () => ({ setUser, updateUser }),
        [updateUser]
    );

    return <UserManagerContext.Provider value={managerValue}>
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    </UserManagerContext.Provider>;

};

export const useUser = () => {
    const data = React.useContext(UserContext);
    if (data === undefined) throw new Error();
    const { user } = data;
    return { user };
};

export const useUserManager = () => {
    const manager = React.useContext(UserManagerContext);
    if (manager === undefined) throw new Error();
    const { setUser, updateUser } = manager;
    return { setUser, updateUser };
};